module.exports = __webpack_public_path__ + "static/media/background2.0d468b0b.png";